module.exports = __webpack_public_path__ + "img/huawei-y6.32b7c09d.jpg";